module.exports = __webpack_public_path__ + "287d22711c81ce960a0e64b73fafe5a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Emerald@2x.png
// module id = 317
// module chunks = 0